/* eslint-disable no-restricted-syntax */
export const isObject = (obj) => {
  const type = typeof obj;
  return (type === 'function' || type === 'object') && !!obj;
}
/* istanbul ignore next */
export const shallowEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }
  return true;
};
/* istanbul ignore next */
export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }
  return true;
};

export const changeNameKeysInArrayItems = (originalArray, arrayParKeys) => {
  const tempArray = originalArray.map((el) => {
    const arrayEntries = Object.entries(el).map((entrie) => {
      const entrieFiltered = arrayParKeys.filter((parKeys) => entrie[0] === parKeys[0]);
      if (entrieFiltered.length > 0) return [entrieFiltered[0][1], entrie[1]];
      return entrie;
    });
    return Object.fromEntries(arrayEntries);
  });
  return tempArray;
};